import R from 'ramda'

const FACEBOOK_ONETIME_DISPLAY_TYPE = 'Send Facebook One Time Consent'
const FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'

const isOneTimeRequest = R.pathEq(
  ['message', 'message', 'attachment', 'payload', 'template_type'],
  'one_time_notif_req'
)
const hasWidgetDmType = R.propEq('type', FACEBOOK_DM_WIDGET_TYPE)
const isOneTimeConsentAction = R.both(isOneTimeRequest, hasWidgetDmType)

const convertFacebookConsentWidgetActionToFormAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_DISPLAY_TYPE),
  oneTimeConsentTitle: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'title'
  ])
})

export {
  isOneTimeConsentAction,
  convertFacebookConsentWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-onetime-consent.js